import React from "react"
import {Typography} from "@mui/material";
import {
    SosTextfragmentFragment
} from "../../../../packages/graphql-layer/src/queries/fragments/__generated__/SOSTextfragment.fragment";
import CCOContainer from "../../fundamentals/CCOContainer";
import CCORichText from "../../fundamentals/CCORichText/CCORichText";
import {metaDataProperty} from "../../preview/previewMetaData";
import {usePreviewContext} from "../../../context/PreviewContext";

export interface Props {
    sosTextFragment: SosTextfragmentFragment,
    dataCypress?: string
}

function C029TextFragment(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    const fragmentTxt = getTextFragment(props.sosTextFragment);
    return (
        <CCOContainer id={props.sosTextFragment.id} dataCypress={props.dataCypress}>
            {props.sosTextFragment.title ?
                <Typography marginBottom={2} variant="h3" {...metaDataProperty(isPreview, 'properties.title', props.sosTextFragment.id)}>
                    {props.sosTextFragment.title}
                </Typography> : <></>}

            {fragmentTxt ?
                <CCORichText metadataId={props.sosTextFragment.id} textAsTree={fragmentTxt.textAsTree} propertyName='properties.detailText'/>
                : <></>}
        </CCOContainer>
    )
}

function getTextFragment(textFragment: SosTextfragmentFragment) {
    if (textFragment.detailText && textFragment.detailText.textAsTree) {
        return textFragment.detailText;
    } else {
        return textFragment.teaserText
    }
}

export default C029TextFragment;